<script>
const categories = [
  {
    category: [
      { label: "1" },
      { label: "2" },
      { label: "3" },
      { label: "4" },
      { label: "5" },
      { label: "6" },
      { label: "7" },
      { label: "8" },
      { label: "9" },
      { label: "10" },
      { label: "11" },
      { label: "12" },
      { label: "13" },
      { label: "14" },
      { label: "15" },
      { label: "16" },
      { label: "17" },
      { label: "18" },
      { label: "19" },
      { label: "20" },
      { label: "21" },
      { label: "22" },
      { label: "23" },
      { label: "24" },
      { label: "25" },
      { label: "26" },
      { label: "27" },
      { label: "28" },
      { label: "29" },
      { label: "30" }
    ]
  }
];
// STEP 3- Construct the dataset comprising combination series
const dataset = [
  {
    seriesName: "Tidak Hadir",
    color: "#F1F2F8",
    data: [
      { value: "16000" },
      { value: "20000" },
      { value: "18000" },
      { value: "19000" },
      { value: "15000" },
      { value: "21000" },
      { value: "16000" },
      { value: "20000" },
      { value: "17000" },
      { value: "25000" },
      { value: "19000" },
      { value: "23000" },
      { value: "16000" },
      { value: "20000" },
      { value: "18000" },
      { value: "19000" },
      { value: "15000" },
      { value: "21000" },
      { value: "16000" },
      { value: "20000" },
      { value: "17000" },
      { value: "25000" },
      { value: "19000" },
      { value: "23000" },
      { value: "25000" },
      { value: "19000" },
      { value: "23000" },
      { value: "16000" },
      { value: "20000" },
      { value: "18000" }
    ]
  },
  {
    seriesName: "Hadir",
    renderAs: "spline",
    color: "#8F8BFF",
    data: [
      { value: "14000" },
      { value: "15000" },
      { value: "13000" },
      { value: "14000" },
      { value: "11000" },
      { value: "17000" },
      { value: "11000" },
      { value: "14000" },
      { value: "11000" },
      { value: "18000" },
      { value: "12000" },
      { value: "17000" },
      { value: "14000" },
      { value: "15000" },
      { value: "13000" },
      { value: "14000" },
      { value: "11000" },
      { value: "17000" },
      { value: "11000" },
      { value: "14000" },
      { value: "11000" },
      { value: "18000" },
      { value: "12000" },
      { value: "17000" },
      { value: "11000" },
      { value: "17000" },
      { value: "11000" },
      { value: "14000" },
      { value: "11000" },
      { value: "18000" }
    ]
  }
];

// STEP 4: Configure your chart
const dataSource = {
  chart: {
    caption: "",
    subCaption: "",
    xAxisname: "Hari",
    yAxisName: "Jumlah",
    numberPrefix: "",
    divlineColor: "#999999",
    divLineIsDashed: "1",
    divLineDashLen: "1",
    divLineGapLen: "1",
    toolTipColor: "#ffffff",
    toolTipBorderThickness: "0",
    toolTipBgColor: "#000000",
    toolTipBgAlpha: "80",
    toolTipBorderRadius: "5",
    toolTipPadding: "10",
    theme: "fusion"
  },
  categories: categories,
  dataset: dataset
};

export default {
  name: "app",
  data() {
    return {
      type: "mscombi2d",
      renderAt: "chart-container",
      width: "100%",
      height: "450",
      dataFormat: "json",
      dataSource
    };
  }
};
</script>

<template>
  <div id="bar-chart">
    <div id="chart-container">
      <fusioncharts
        :type="type"
        :width="width"
        :height="height"
        :dataformat="dataFormat"
        :dataSource="dataSource"
      >
      </fusioncharts>
    </div>
  </div>
</template>
